module.exports = __webpack_public_path__ + "static/media/sketch2.9b9e90a4.jpg";